import moment from 'moment';
export var getTime = function () {
    var now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};
export var ensureMoment = function (value) {
    if (!value)
        return null;
    if (moment.isMoment(value))
        return value;
    if (typeof value === 'string')
        return moment.utc(value.substr(0, 10));
    if (value instanceof Date)
        return moment.utc(value);
    return null;
};
export var toISODate = function (value) {
    if (!value)
        return null;
    if (moment.isMoment(value))
        return value.format('YYYY-MM-DD');
    if (value instanceof Date)
        return moment.utc(value).format('YYYY-MM-DD');
    if (typeof value === 'string')
        return value.substr(0, 10);
    return null;
};
export var getHoursMinutesFromTime = function (time) {
    if (Number.isNaN(time))
        return '';
    var sign = time < 0 ? '-' : '';
    var value = Math.abs(time);
    var h = Math.floor(value / 60);
    var m = value % 60;
    return "".concat(sign).concat(h, ":").concat(m < 10 ? '0' : '').concat(m);
};
